export enum JoinCriteriaOperator {
  OR = ',',
}
